import { GetterTree, ActionTree } from 'vuex'
import _filter from 'lodash/filter'
import _find from 'lodash/find'

import { dataService } from '@/service/firebase'

import { IComment } from '@/models'
import i18n from '@/i18n'

class State {
    _comments: Array<IComment> = []
}

const getters = {
    comments( state ) {
        return state._comments
    },

    commentById( state ) {
        return ( id: string ) => _find( state._comments, { id: id } )
    },

    commentsByAssociationId( state ) {
        return ( id: string ) => _filter( state._comments, { relatedAssociation: id } )
    },

    commentsByUserId( state ) {
        return ( id: string ) => _filter( state._comments, { relatedUser: id } )
    },

    totalComments( state ) {
        return Object.keys( state._comments ).length
    }
} as GetterTree<State, any>

const actions = {
    createLocalComment( { dispatch, rootState }, comment: { associationId: string; contentRaw: string; infoOnUpdate: boolean } ) {
        const localComments = localStorage.getItem( 'localComments' )
        const createdComment = {
            contentRaw: comment.contentRaw,
            infoOnUpdate: comment.infoOnUpdate,
            dateCreated: dataService.Timestamp.fromDate( new Date ),
            relatedAssociation: comment.associationId,
            relatedUser: rootState.usersModule._currentUser.id,
            language: i18n.locale
        }

        if ( !localComments ) {
            localStorage.setItem( 'localComments', JSON.stringify( [createdComment] ) )
        } else {
            const existingAssociations = JSON.parse( localComments )

            existingAssociations.push( createdComment )
            localStorage.setItem( 'localComments', JSON.stringify( existingAssociations ) )
        }
    },

    createComment( { dispatch, rootState }, comment: { associationId: string; contentRaw: string; infoOnUpdate: boolean } ) {
        dispatch( 'set', {
            contentRaw: comment.contentRaw,
            infoOnUpdate: comment.infoOnUpdate,
            dateCreated: dataService.Timestamp.fromDate( new Date ),
            relatedAssociation: comment.associationId,
            relatedUser: rootState.usersModule._currentUser.id,
            language: i18n.locale
        } )
        .then( ( result ) => {
            dispatch( 'usersModule/setRelatedComment', result, { root: true } )
            dispatch( 'associationsModule/setRelatedComment', { commentId: result, associationId: comment.associationId }, { root: true } )
        } )
        .catch( error => console.error( error ) )
    }
} as ActionTree<State, any>

const CommentsModule = {
    firestorePath: 'Comments',
    firestoreRefType: 'collection',
    moduleName: 'commentsModule',
    statePropName: '_comments',
    namespaced: true,
    state: new State(),
    getters,
    actions
}

export default CommentsModule
